/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('StudentInfosCtrl', function($scope, $routeParams, identity, Achievement) {
    $scope.me = identity;

    $scope.isMyWall = () => $scope.me.login === $scope.user.login;

    return $scope.achievements = Achievement.query({
        login: $scope.user.login});
});
